import { ThemeProvider } from '@mui/material/styles';
import { Navigate, Routes as ReactRouterDOMRoutes, Route } from 'react-router-dom';

import RequireAuth from '@/components/routes/RequireAuth';
import ResetPasswordForm from '@/components/user/ResetPasswordForm';
import { FF_PHARMACIST_ENABLE_SHIPMENTS, FF_PHARMACY_REFERRALS } from '@/constants/featureFlags';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import ForgotPassword from '@/pages/auth/ForgotPassword';
import ResetPassword from '@/pages/auth/ResetPassword';
import SignIn from '@/pages/auth/SignIn';
import Error404 from '@/pages/error/404';
import PharmacistInventory from '@/pages/inventory/PharmacistInventory';
import PharmacistOrders from '@/pages/orders/PharmacistOrders';
import ProfileDetails from '@/pages/user/ProfileDetails';
import montuTheme from '@montugroup/circuit-shared/theme';

import SignOut from '@/components/auth/SignOut';
import TermsAndPolicy from '@/components/auth/TermsAndPolicy';
import OnboardingForm from '@/components/onboarding/OnboardingForm';
import OnboardingSuccess from '@/components/onboarding/OnboardingSuccess';
import PharmacyOnboard from '@/pages/onboarding/PharmacyOnboard';

// TODO: Once the rebranding is rolled out, the contents in alternalead.scss should be baselined, and then the file + import removed.

import SetPassword from '@/pages/auth/SetPassword';
import PharmacistEscript from '@/pages/escript/PharmacistEscript';
import PharmacistShipmentAcknowledgement from '@/pages/shipment/PharmacistShipmentAcknowledgement';
import PharmacistShipments from '@/pages/shipment/PharmacistShipments';
import HealthCheck from './healthCheck';
import {
  ESCRIPT_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  HEALTH_CHECK_ROUTE,
  INVENTORY_ROUTE,
  LOGIN_ONBOARDKEY_ROUTE,
  LOGIN_ROUTE,
  LOGOUT_ROUTE,
  ONBOARD_ROUTE,
  ORDERS_ROUTE,
  PASSWORD_ROUTE,
  POLICY_ROUTE,
  PROFILE_DETAIL_ROUTE,
  RESET_PASSWORD_LEGACY_ROUTE,
  RESET_PASSWORD_ROUTE,
  ROOT_ROUTE,
  SHIPMENT_ACKNOWLEDGEMENT_ROUTE,
  SHIPMENTS_ROUTE,
} from './route-paths';

function Routes() {
  const { flags } = useFeatureFlags();

  return (
    <ThemeProvider theme={montuTheme}>
      <ReactRouterDOMRoutes>
        <Route path={ROOT_ROUTE} Component={SignIn} />
        <Route path={LOGIN_ROUTE} Component={SignIn} />
        <Route path={LOGIN_ONBOARDKEY_ROUTE} Component={SetPassword} />
        <Route path={FORGOT_PASSWORD_ROUTE} Component={ForgotPassword} />
        <Route path={RESET_PASSWORD_ROUTE} Component={ResetPassword} />
        <Route path={RESET_PASSWORD_LEGACY_ROUTE} Component={ResetPassword} />
        <Route path={HEALTH_CHECK_ROUTE} Component={HealthCheck} />
        <Route path={POLICY_ROUTE} Component={TermsAndPolicy} />
        <Route path={ONBOARD_ROUTE} element={<PharmacyOnboard />}>
          <Route index element={<OnboardingForm />} />
          <Route path="success" element={<OnboardingSuccess />} />
        </Route>
        <Route element={<RequireAuth />}>
          <Route path={LOGOUT_ROUTE} element={<SignOut />} />
          <Route path={PASSWORD_ROUTE} element={<ResetPasswordForm />} />
          <Route path={PROFILE_DETAIL_ROUTE} element={<ProfileDetails />} />
          <Route path={INVENTORY_ROUTE} element={<PharmacistInventory />} />
          {/* TODO: Deprecated URL, remove after no longer used by CRM/users */}
          <Route path="/pharmacist/orders" element={<Navigate to={{ pathname: '/orders' }} replace />} />
          <Route path={ORDERS_ROUTE} element={<PharmacistOrders />} />
          {flags[FF_PHARMACIST_ENABLE_SHIPMENTS] ? (
            <Route path={SHIPMENTS_ROUTE} element={<PharmacistShipments />} />
          ) : null}
          {flags[FF_PHARMACIST_ENABLE_SHIPMENTS] ? (
            <Route path={SHIPMENT_ACKNOWLEDGEMENT_ROUTE} element={<PharmacistShipmentAcknowledgement />} />
          ) : null}
          {flags[FF_PHARMACY_REFERRALS] ? <Route path={ESCRIPT_ROUTE} element={<PharmacistEscript />} /> : null}
        </Route>
        <Route path="*" Component={Error404} />
      </ReactRouterDOMRoutes>
    </ThemeProvider>
  );
}

export default Routes;
